/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Price_LineInputs */

const en_st_price_line = /** @type {(inputs: St_Price_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio is Rp399k / $39 per workspace — 5 seats, unlimited clients, proposals, handover and cost per feature.`)
};

const id_st_price_line = /** @type {(inputs: St_Price_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio Rp399 rb / $39 per workspace — 5 seat, klien tak terbatas, proposal, serah terima, dan biaya per fitur.`)
};

/**
* | output |
* | --- |
* | "Studio is Rp399k / $39 per workspace — 5 seats, unlimited clients, proposals, handover and cost per feature." |
*
* @param {St_Price_LineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_price_line = /** @type {((inputs?: St_Price_LineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Price_LineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_price_line(inputs)
	return en_st_price_line(inputs)
});